import { render, staticRenderFns } from "./joinSentence.vue?vue&type=template&id=74b4ed12&scoped=true"
import script from "./joinSentence.vue?vue&type=script&lang=js"
export * from "./joinSentence.vue?vue&type=script&lang=js"
import style0 from "./joinSentence.vue?vue&type=style&index=0&id=74b4ed12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b4ed12",
  null
  
)

export default component.exports